var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container"},[_c('img',{ref:"img",attrs:{"src":_vm.imgSrc}}),_c('span',[_vm._v(_vm._s(_vm.nw)+" x "+_vm._s(_vm.nh))]),_c('canvas',{ref:"canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }